﻿'use strict';

require('validation/validation');
require('passwords/passwords');
